import React from 'react';
import Icon from '../../../components/AppIcon';

const PermitTypeSelector = ({ selectedType, onTypeSelect, permitTypes }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Permit Type</h2>
          <p className="text-sm text-muted-foreground">Select the type of work permit required</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {permitTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeSelect(type?.id)}
            className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-background'
            }`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                selectedType === type?.id ? 'bg-primary/20' : 'bg-muted'
              }`}>
                <Icon 
                  name={type?.icon} 
                  size={20} 
                  color={selectedType === type?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground mb-1">{type?.name}</h3>
                <p className="text-xs text-muted-foreground line-clamp-2">{type?.description}</p>
              </div>
            </div>
            {selectedType === type?.id && (
              <div className="mt-3 flex items-center gap-2 text-xs text-primary">
                <Icon name="CheckCircle2" size={14} />
                <span className="font-medium">Selected</span>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PermitTypeSelector;